import cls from "./AdminLeaderboardPanel.module.scss";

export default function AdminLeaderboardPanel({ leaderboard }) {
 const rows = leaderboard || [];

  return (
    <section className={cls.panel}>
      <div className={cls.header}>
        <p className={cls.kicker}>RANKING</p>
        <h3 className={cls.title}>Live Leaderboard</h3>
      </div>

      {!rows.length ? (
        <p className={cls.empty}>No leaderboard data yet.</p>
      ) : (
        <ol className={cls.list}>
          {rows.map((row, idx) => (
            <li key={row.playerId || idx} className={cls.item}>
              <span className={cls.rank}>#{idx + 1}</span>
              <div className={cls.playerMeta}>
                <strong>{row.displayName || "Unknown"}</strong>
                <small>
                  W:{row.wins || 0} L:{row.losses || 0} • Coins:{row.currentCoins || 0}
                </small>
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
